import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import api from '../../services/api';
import { AuthContext } from '../../context/Auth/AuthContext';
import { toast } from 'react-toastify';
import toastError from "../../errors/toastError";
import { i18n } from '../../translate/i18n';
import { useHistory, useLocation } from 'react-router-dom';
import { setKanbanLaneOrder, getKanbanLaneOrder } from '../../services/companyKanbanService';
import { Button, TextField, Paper, FormControl, InputLabel, Select, FormControlLabel, Checkbox, Typography } from '@material-ui/core';


import { format } from 'date-fns';
import { Can } from '../../components/Can';
import MainContainer from '../../components/MainContainer';
import MainHeader from '../../components/MainHeader';
import MainHeaderButtonsWrapper from '../../components/MainHeaderButtonsWrapper';
import Title from '../../components/Title';
import KanbanBoard from './KanbanBoard';
import KanbanBoardModal from '../../components/KanbanBoardModal';
import KanbanAdminModal from '../../components/KanbanAdminModal';
import FinalizacaoVendaModal from '../../components/FinalizacaoVendaModal';
import { MenuItem, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'; // Añadir componentes para modal
import KanbanTagMenu from "./KanbanTagMenu";
import ErrorBoundary from '../../components/ErrorBoundary';
import { TagsFilter } from "../../components/TagsFilter";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as XLSX from "xlsx";
import Chip from "@material-ui/core/Chip";
import { IconButton, Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import PublishIcon from '@material-ui/icons/Publish';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import Box from '@material-ui/core/Box';
import PageHelpGuide from '../../components/PageHelpGuide';
import { KANBAN_HELP_DATA } from '../../constants/pageHelp/kanbanHelp';
import { getStandardButtonStyles } from '../../styles/standardButtons';

const useStyles = makeStyles(theme => ({
  ...getStandardButtonStyles(theme),
  rootPaper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
    overflow: 'hidden',
    borderRadius: 16,
    backgroundColor: theme.palette.type === 'dark' ? '#2A2D32 !important' : theme.palette.background.paper,
  },
  mainPaper: {
    flex: 1,
    display: 'flex',
    padding: theme.spacing(1),
    overflowX: 'auto',
    ...(theme.scrollbarStylesNeutral || theme.scrollbarStyles),
    borderRadius: 16,
    backgroundColor: 'transparent',
  },
  filterPaper: {
    padding: '16px',
    margin: '0 0 16px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.02)',
    border: theme.palette.type === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(0, 0, 0, 0.08)',
    borderRadius: 12,
  },
  button: {
    borderRadius: '10px',
  },
  dateInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
    },
    marginRight: theme.spacing(1),
  },
  sortSelect: {
    minWidth: 150,
    marginRight: theme.spacing(1),
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
    },
  },
  neonButtonPrimary: {
    borderRadius: '8px',
    backgroundColor: '#00e5ff',
    color: '#000',
    fontWeight: '600',
    textTransform: 'none',
    border: '1px solid #00e5ff',
    boxShadow: '0 0 5px rgba(0,229,255,0.3)',
    '&:hover': {
      backgroundColor: '#00b3cc',
      boxShadow: '0 0 10px rgba(0,229,255,0.6)',
    }
  },
  neonButtonSecondary: {
    borderRadius: '8px',
    backgroundColor: 'rgba(0, 229, 255, 0.05)',
    color: '#00e5ff',
    fontWeight: '600',
    textTransform: 'none',
    border: '1px solid rgba(0, 229, 255, 0.5)',
    '&:hover': {
      backgroundColor: 'rgba(0, 229, 255, 0.15)',
      border: '1px solid #00e5ff',
      boxShadow: '0 0 8px rgba(0,229,255,0.4)',
    }
  },
  neonButtonDanger: {
    borderRadius: '8px',
    backgroundColor: 'rgba(255, 23, 68, 0.05)',
    color: '#ff1744',
    fontWeight: '600',
    textTransform: 'none',
    border: '1px solid rgba(255, 23, 68, 0.5)',
    '&:hover': {
      backgroundColor: 'rgba(255, 23, 68, 0.15)',
      border: '1px solid #ff1744',
      boxShadow: '0 0 8px rgba(255, 23, 68, 0.4)',
    }
  },
  neonInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: 'rgba(0,0,0,0.2)',
      '& fieldset': {
        borderColor: 'rgba(0, 229, 255, 0.3)',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(0, 229, 255, 0.6)',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#00e5ff',
        boxShadow: '0 0 6px rgba(0, 229, 255, 0.3)',
      },
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255,255,255,0.7)',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#00e5ff',
    }
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    paddingBottom: theme.spacing(1.5),
    borderBottom: '1px solid rgba(0, 229, 255, 0.1)',
    '&:last-child': {
      borderBottom: 'none',
      paddingBottom: 0,
    }
  },
  iconButtonBox: {
    borderRadius: '6px',
    backgroundColor: 'rgba(0, 229, 255, 0.05)',
    border: '1px solid rgba(0, 229, 255, 0.5)',
    padding: '6px',
    color: '#00e5ff',
    '&:hover': {
      backgroundColor: 'rgba(0, 229, 255, 0.15)',
      border: '1px solid #00e5ff',
      boxShadow: '0 0 8px rgba(0,229,255,0.4)',
    },
    '&.Mui-disabled': {
      borderColor: 'rgba(255, 255, 255, 0.1)',
      color: 'rgba(255, 255, 255, 0.3)',
      backgroundColor: 'transparent',
      boxShadow: 'none'
    }
  },
  iconButtonBoxDanger: {
    borderRadius: '6px',
    backgroundColor: 'rgba(255, 23, 68, 0.05)',
    border: '1px solid rgba(255, 23, 68, 0.5)',
    padding: '6px',
    color: '#ff1744',
    '&:hover': {
      backgroundColor: 'rgba(255, 23, 68, 0.15)',
      border: '1px solid #ff1744',
      boxShadow: '0 0 8px rgba(255, 23, 68, 0.4)',
    },
    '&.Mui-disabled': {
      borderColor: 'rgba(255, 255, 255, 0.1)',
      color: 'rgba(255, 255, 255, 0.3)',
      backgroundColor: 'transparent',
      boxShadow: 'none'
    }
  },
}));

const Kanban = () => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const urlBoardId = searchParams.get('boardId');
  const urlBrandId = searchParams.get('brandId');
  const urlTicketId = searchParams.get('ticketId');
  // Estado Global para el Menú de Etiquetas
  const [tagMenuConfig, setTagMenuConfig] = useState(null);
  const [addSubTagModalOpen, setAddSubTagModalOpen] = useState(false);
  const [targetLaneIdForAdd, setTargetLaneIdForAdd] = useState(null);

  const [newSubTagName, setNewSubTagName] = useState('');
  const fileInputRef = useRef(null);

  // [PLAN 1230] Estado para cierre comercial al arrastrar a etapa ganada/perdida
  const [closingTicketData, setClosingTicketData] = useState(null);
  const [finalizacaoModalOpen, setFinalizacaoModalOpen] = useState(false);

  const handleOpenTagMenu = (config) => {
    setTagMenuConfig(config);
  };

  const handleCloseTagMenu = () => {
    setTagMenuConfig(null);
  };

  const handleSaveSubTag = async () => {
    if (!newSubTagName.trim()) return;
    if (!targetLaneIdForAdd) {
      toast.error("Error: Lane ID missing");
      return;
    }

    try {
      const normalizedNewTag = newSubTagName.trim();
      let tagId;

      // FIX: Force create unique tag instance for independent checklists
      try {
        const { data: created } = await api.post('/tags', {
          name: normalizedNewTag,
          color: '#555',
          kanban: 0, // Tag normal (no etapa)
          kanbanBoardId: selectedBoard, // [ANTIGRAVITY] Link to Board for consistency
          forceCreate: true // [ANTIGRAVITY] Require new instance
        });
        tagId = created.id || created.tag?.id;
      } catch (e) {
        console.error("Error creating tag entity", e);
        toast.error("Error creating tag entity");
        return;
      }

      if (!tagId) return;

      // 2. Obtener datos actuales de la Etapa (Lane) para actualizar su lista
      const { data: laneData } = await api.get(`/tags/${targetLaneIdForAdd}`);

      // Determinar IDs actuales
      let currentIds = [];
      if (laneData.kanbanLaneTags && laneData.kanbanLaneTags.length > 0) {
        currentIds = laneData.kanbanLaneTags.map(klt => klt.tagId);
      }

      if (currentIds.includes(tagId)) {
        toast.error(i18n.t("tagsKanban.toasts.tagExists"));
        return;
      }

      // 3. Actualizar con la nueva lista de IDs
      const newIds = [...currentIds, tagId];

      await api.put(`/tags/${targetLaneIdForAdd}`, {
        ...laneData,
        laneTagIds: newIds
      });

      toast.success(i18n.t("tagsKanban.toasts.added"));
      setAddSubTagModalOpen(false);
      setNewSubTagName('');

      // 4. Refrescar etiquetas del tablero
      fetchTags();

    } catch (err) {
      toastError(err);
    }
  };


  const { user, socket } = useContext(AuthContext);
  const [tags, setTags] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [externalTicketsCount, setExternalTicketsCount] = useState(0);
  const [lanes, setLanes] = useState([]);
  const [lanePagination, setLanePagination] = useState({});
  const [laneTotals, setLaneTotals] = useState({});
  const [currency, setCurrency] = useState("$");

  useEffect(() => {
    async function loadCurrency() {
      try {
        const { data } = await api.get("/settings");
        const curr = data?.find(s => s.key === "system_currency");
        if (curr && curr.value) {
          setCurrency(curr.value);
        }
      } catch (err) {
        console.error("Error loading system currency:", err);
      }
    }
    loadCurrency();
  }, []);
  /*
  const [startDate, setStartDate] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'));
  */
  // Default: Mostrar todo el historial (sin filtro de fecha)
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedConnections, setSelectedConnections] = useState([]);
  const [adminModalOpen, setAdminModalOpen] = useState(false);
  const [selectedLanes, setSelectedLanes] = useState([]);

  // Debounce for search
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchTickets();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  const queueIds = user.queues.map(queue => queue.id);

  const [sortOrder, setSortOrder] = useState(() => {
    return localStorage.getItem('sortOrder') || 'ticketNumber';
  });

  const [laneOrder, setLaneOrder] = useState(null);
  const laneOrderRef = useRef(null);
  const [loadingLaneOrder, setLoadingLaneOrder] = useState(true);

  useEffect(() => {
    laneOrderRef.current = laneOrder;
  }, [laneOrder]);

  const [boards, setBoards] = useState([]);
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [boardModalOpen, setBoardModalOpen] = useState(false);
  const [editingBoardId, setEditingBoardId] = useState(null);

  useEffect(() => {
    // Al entrar a Kanban/Embudos, asegurar que no queden filtros guardados si no se especifican por URL
    if (!urlBoardId && !urlBrandId) {
      localStorage.removeItem('kanbanSelectedBrand');
      localStorage.removeItem('kanbanSelectedBoard');
    }
  }, [urlBoardId, urlBrandId]);

  useEffect(() => {
    if (urlBoardId) {
      const boardNum = Number(urlBoardId);
      if (boards.length > 0) {
        const target = boards.find(b => Number(b.id) === boardNum);
        if (target) {
          if (target.brandId) {
            setSelectedBrand(Number(target.brandId));
          }
          setSelectedBoard(target.id);
          return;
        }
      }
      setSelectedBoard(boardNum);
      if (urlBrandId) {
        setSelectedBrand(Number(urlBrandId));
      }
    } else if (urlBrandId) {
      setSelectedBrand(Number(urlBrandId));
    }
  }, [urlBoardId, urlBrandId, boards]);

  useEffect(() => {
    if (!urlTicketId || lanes.length === 0) return;
    const timer = setTimeout(() => {
      const card = document.getElementById(`kanban-ticket-${urlTicketId}`);
      if (card) {
        card.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [urlTicketId, lanes]);

  // Import Modal State
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [importWhatsappId, setImportWhatsappId] = useState("");
  const [whatsapps, setWhatsapps] = useState([]);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const { data } = await api.get("/brands");
        setBrands(data.brands || data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchBrands();
  }, []);

  useEffect(() => {
    const fetchWhatsapps = async () => {
      try {
        const { data } = await api.get("/whatsapp");
        setWhatsapps(data);
      } catch (err) {
        toastError(err);
      }
    };
    fetchWhatsapps();
  }, []);

  useEffect(() => {
    localStorage.setItem('sortOrder', sortOrder);
  }, [sortOrder]);

  // Carregar ordem das lanes do banco de dados
  useEffect(() => {
    const loadLaneOrder = async () => {
      setLoadingLaneOrder(true);
      try {
        const savedOrder = await getKanbanLaneOrder(selectedBoard);
        setLaneOrder(savedOrder);
        laneOrderRef.current = savedOrder;
      } catch (error) {
        console.error('Erro ao carregar ordem das lanes:', error);
      } finally {
        setLoadingLaneOrder(false);
      }
    };

    if (user && user.id && selectedBoard) {
      loadLaneOrder();
    }
  }, [user, selectedBoard]);

  // ... (unchanged code)



  useEffect(() => {
    const fetchBoards = async () => {
      try {
        const { data } = await api.get("/kanban-boards");
        setBoards(data);
        if (urlBoardId && Array.isArray(data) && data.length > 0) {
          const target = data.find(b => Number(b.id) === Number(urlBoardId));
          if (target) {
            if (target.brandId) setSelectedBrand(Number(target.brandId));
            setSelectedBoard(Number(target.id));
          }
        }
      } catch (err) {
        toastError(err);
      }
    };
    fetchBoards();
  }, [urlBoardId]);

  const [showClosed, setShowClosed] = useState(() => {
    return localStorage.getItem('kanbanShowClosed') === 'true';
  });

  const [showUnique, setShowUnique] = useState(() => {
    return localStorage.getItem('kanbanShowUnique') === 'true';
  });

  const [showDashboard, setShowDashboard] = useState(() => {
    return localStorage.getItem('kanbanShowDashboard') === 'true';
  });

  // ...

  useEffect(() => {
    localStorage.setItem('kanbanShowClosed', showClosed);
    localStorage.setItem('kanbanShowUnique', showUnique);
    localStorage.setItem('kanbanShowDashboard', showDashboard);
    fetchTickets();
  }, [showClosed, showUnique, showDashboard]);

  useEffect(() => {
    fetchTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBoard]);

  const fetchTags = useCallback(async () => {
    if (!selectedBoard) return;
    try {
      const params = {
        kanbanBoardId: selectedBoard
      };
      const response = await api.get('/tag/kanban/', { params });
      const fetchedTags = response.data.lista || [];
      setTags(fetchedTags);
      fetchTickets(fetchedTags);
    } catch (error) {
      console.log(error);
    }
  }, [selectedBoard]);

  const isMounted = useRef(true);

  const fetchTagsRef = useRef(fetchTags);
  useEffect(() => {
    fetchTagsRef.current = fetchTags;
  });

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const fetchLaneTotals = useCallback(async () => {
    if (!selectedBoard) return;
    try {
      const baseParams = {
        queueIds: JSON.stringify(queueIds),
        dateStart: startDate,
        dateEnd: endDate,
        kanbanBoardId: selectedBoard,
        showClosed: showClosed,
        showUnique: showUnique,
        showDashboard: showDashboard,
        searchParam: searchQuery,
        tags: JSON.stringify(selectedTags.map(t => t.id)),
        whatsappIds: JSON.stringify(selectedConnections.map(c => c.id))
      };
      const { data: totals } = await api.get('/ticket/kanban/totals', { params: baseParams });
      if (isMounted.current) {
        setLaneTotals(totals);
      }
    } catch (err) {
      console.error("Error refreshing kanban totals", err);
    }
  }, [selectedBoard, queueIds, startDate, endDate, showClosed, showUnique, showDashboard, searchQuery, selectedTags, selectedConnections]);

  const fetchTickets = async (fetchedTags = tags) => {
    if (!selectedBoard) return;
    try {
      const baseParams = {
        queueIds: JSON.stringify(queueIds),
        dateStart: startDate,
        dateEnd: endDate,
        kanbanBoardId: selectedBoard,
        showClosed: showClosed,
        showUnique: showUnique,
        showDashboard: showDashboard,
        searchParam: searchQuery,
        tags: JSON.stringify(selectedTags.map(t => t.id)),
        whatsappIds: JSON.stringify(selectedConnections.map(c => c.id))
      };

      // 1. Fetch totals
      const { data: totals } = await api.get('/ticket/kanban/totals', { params: baseParams });
      if (isMounted.current) {
        setLaneTotals(totals);
      }

      // 2. Fetch first page for all lanes (tags + lane0)
      let allTickets = [];
      const newPagination = {};
      
      const laneIdsToFetch = ['lane0', ...fetchedTags.map(t => String(t.id))];
      
      for (const laneId of laneIdsToFetch) {
        try {
          const { data } = await api.get('/ticket/kanban', {
            params: { ...baseParams, laneId, pageNumber: 1 }
          });
          allTickets = [...allTickets, ...data.tickets];
          newPagination[laneId] = { page: 1, hasMore: data.hasMore };
          if (data.externalCount !== undefined) setExternalTicketsCount(data.externalCount);
        } catch (e) {
          console.error('Error fetching lane', laneId, e);
          newPagination[laneId] = { page: 1, hasMore: false };
        }
      }

      if (isMounted.current) {
        // Remove duplicates just in case
        const uniqueTickets = [];
        const seen = new Set();
        for (const t of allTickets) {
          if (!seen.has(t.id)) {
            seen.add(t.id);
            uniqueTickets.push(t);
          }
        }
        
        setTickets(uniqueTickets);
        setLanePagination(newPagination);
        
        // We calculate externalCount from laneTotals if needed, or backend can return it.
        // Actually, backend /totals does not return externalCount explicitly, it's just the sum.
        // Let's rely on organizeLanes to group them
        organizeLanes(fetchedTags, uniqueTickets, laneOrderRef.current);
      }
    } catch (err) {
      console.log(err);
      if (isMounted.current) {
        setTickets([]);
      }
    }
  };

  useEffect(() => {
    const companyId = user.companyId;

    const onAppMessage = data => {
      if (data.action === "update" && data.ticket) {
        updateTicket(data.ticket);
      } else if (['create', 'update', 'delete'].includes(data.action)) {
        fetchTickets();
      }
    };

    const onTagMessage = data => {
      // Si se crea, actualiza o borra una etiqueta (incluyendo lanes de Kanban), refrescar todo
      if (['create', 'update', 'delete'].includes(data.action)) {
        if (fetchTagsRef.current) fetchTagsRef.current();
      }
    };

    socket.on(`company-${companyId}-ticket`, onAppMessage);
    socket.on(`company-${companyId}-appMessage`, onAppMessage);
    socket.on(`company${companyId}-tag`, onTagMessage);

    return () => {
      socket.off(`company-${companyId}-ticket`, onAppMessage);
      socket.off(`company-${companyId}-appMessage`, onAppMessage);
      socket.off(`company${companyId}-tag`, onTagMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, user.companyId]);

  const fetchMoreTickets = async (laneId) => {
    if (!selectedBoard || !lanePagination[laneId] || !lanePagination[laneId].hasMore) return;
    
    const nextPage = lanePagination[laneId].page + 1;
    
    try {
      const params = {
        queueIds: JSON.stringify(queueIds),
        dateStart: startDate,
        dateEnd: endDate,
        kanbanBoardId: selectedBoard,
        showClosed: showClosed,
        showUnique: showUnique,
        showDashboard: showDashboard,
        searchParam: searchQuery,
        tags: JSON.stringify(selectedTags.map(t => t.id)),
        laneId,
        pageNumber: nextPage
      };

      const { data } = await api.get('/ticket/kanban', { params });

      if (data.externalCount !== undefined) setExternalTicketsCount(data.externalCount);
      
      if (isMounted.current) {
        setTickets(prev => {
          const newTickets = [...prev];
          data.tickets.forEach(t => {
            if (!newTickets.find(x => x.id === t.id)) newTickets.push(t);
          });
          organizeLanes(tags, newTickets);
          return newTickets;
        });
        
        setLanePagination(prev => ({
          ...prev,
          [laneId]: { page: nextPage, hasMore: data.hasMore }
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSearchClick = () => {
    fetchTickets();
  };

  const handleStartDateChange = event => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = event => {
    setEndDate(event.target.value);
  };

  const updateTicket = useCallback(updatedTicket => {
    setTickets(prevTickets => {
      const ticketExists = prevTickets.some(t => t.id === updatedTicket.id);
      let newTickets;

      if (ticketExists) {
        // If it exists, but it's closed and we don't show closed, remove it.
        if (!showClosed && updatedTicket.status === "closed") {
          newTickets = prevTickets.filter(t => t.id !== updatedTicket.id);
        } else {
          newTickets = prevTickets.map(ticket =>
            ticket.id === updatedTicket.id ? { ...ticket, ...updatedTicket } : ticket
          );
        }
      } else {
        // If it doesn't exist, add it (unless it's closed and we don't show closed)
        if (showClosed || updatedTicket.status !== "closed") {
          newTickets = [updatedTicket, ...prevTickets];
        } else {
          newTickets = prevTickets;
        }
      }

      // Re-organizamos las lanes con los nuevos datos de los tickets
      organizeLanes(tags, newTickets);
      return newTickets;
    });
    fetchLaneTotals();
  }, [showClosed, organizeLanes, tags, fetchLaneTotals]);

  function getOpportunityValue(ticket) {
    if (!ticket) return 0;
    if (ticket.valorVenda !== undefined && ticket.valorVenda !== null && !isNaN(Number(ticket.valorVenda))) {
      return Number(ticket.valorVenda);
    }
    if (ticket.opportunityValue !== undefined && ticket.opportunityValue !== null && !isNaN(Number(ticket.opportunityValue))) {
      return Number(ticket.opportunityValue);
    }
    if (!ticket.contact) return 0;
    const customFields = ticket.contact.extraInfo || [];
    const valueField = customFields.find(field => field.name === 'valor');
    const opportunityValue = valueField ? parseFloat(valueField.value) : 0;
    return isNaN(opportunityValue) ? 0 : opportunityValue;
  }

  const handleTicketValueChange = useCallback((ticketId, laneId, newValue) => {
    setLaneTotals(prevTotals => {
      if (!prevTotals) return prevTotals;
      const ticket = tickets.find(t => t.id === ticketId);
      const prevVal = ticket ? getOpportunityValue(ticket) : 0;
      const delta = (parseFloat(newValue) || 0) - (parseFloat(prevVal) || 0);

      const targetLaneId = laneId || 'lane0';
      const currentTotal = prevTotals[targetLaneId] || { count: 0, value: 0 };
      const updatedValue = Math.max(0, (currentTotal.value || 0) + delta);

      return {
        ...prevTotals,
        [targetLaneId]: {
          ...currentTotal,
          value: updatedValue
        }
      };
    });
    fetchLaneTotals();
  }, [tickets, fetchLaneTotals]);

  function organizeLanes(fetchedTags = tags, fetchedTickets = tickets, customOrder = null) {
    const activeOrder = customOrder || (laneOrder && laneOrder.length > 0 ? laneOrder : laneOrderRef.current);
    const sortedTickets = [...fetchedTickets];

    if (sortOrder === 'ticketNumber') {
      sortedTickets.sort((a, b) => b.id - a.id);
    } else if (sortOrder === 'lastMessageTime') {
      sortedTickets.sort(
        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
      );
    } else if (sortOrder === 'valorDesc') {
      sortedTickets.sort((a, b) => {
        const valorA = getOpportunityValue(a);
        const valorB = getOpportunityValue(b);
        return valorB - valorA;
      });
    }

    let orderedTagIdsStr = [];
    if (activeOrder && activeOrder.length > 0) {
      orderedTagIdsStr = activeOrder.filter(id => String(id) !== 'lane0').map(id => String(id));
    } else {
      orderedTagIdsStr = fetchedTags.map(t => String(t.id));
    }

    const defaultTickets = sortedTickets.filter(
      ticket => {
        // [ANTIGRAVITY] FOOLPROOF CHECK:
        // Collect IDs of all column tags for the current board
        const laneTagIds = new Set(fetchedTags.map(tag => tag.id));
        
        // Checar se o ticket tem QUALQUER tag de Kanban (global) ou se coincide con alguna columna actual
        const hasAnyKanbanTag = ticket.tags.some(t => 
          Number(t.kanban) === 1 || String(t.kanban) === "1" || t.kanban === true || laneTagIds.has(t.id)
        );

        // Se tem tag de kanban, OMITIR do default (retornar false)
        if (!hasAnyKanbanTag) {
          return true;
        }
        return false;
      }
    );

    const lanesData = [
      {
        id: 'lane0',
        title: i18n.t('tagsKanban.laneDefault'),
        tickets: defaultTickets,
        color: '#757575',
      },
      ...fetchedTags.map(tag => {
        const taggedTickets = sortedTickets.filter(ticket => {
          const hasTag = ticket.tags.some(t => t.id === tag.id);
          if (!hasTag) return false;

          if (showUnique) {
             let maxIndex = -1;
             let bestTagId = null;
             ticket.tags.forEach(t => {
                const index = orderedTagIdsStr.indexOf(t.id.toString());
                if (index > maxIndex) {
                   maxIndex = index;
                   bestTagId = t.id.toString();
                }
             });
             return bestTagId === tag.id.toString();
          }
          
          return true;
        });
        return {
          id: tag.id.toString(),
          title: tag.name,
          tickets: taggedTickets,
          color: tag.color || '#757575',
          laneTags: tag.laneTags || [],
          kanbanLaneTags: [...(tag.kanbanLaneTags || [])].sort((a, b) => a.id - b.id), // Fix: Sort KLT by ID without mutating state
          sendGreetingMessage: tag.sendGreetingMessage || false,
          greetingMessageLane: tag.greetingMessageLane || '',
          kanbanMessageDelay: tag.kanbanMessageDelay !== undefined ? tag.kanbanMessageDelay : 10,
          kanbanMessageDelayUnit: tag.kanbanMessageDelayUnit || 'seconds',
          greetingMessageKanban: tag.greetingMessageKanban || false,
          greetingMessageInbox: tag.greetingMessageInbox || false,
          greetingMessageFlowBuilder: tag.greetingMessageFlowBuilder || false,
          greetingMessageCampaigns: tag.greetingMessageCampaigns || false,
        };
      }),
    ];

    // [ANTIGRAVITY] FIX: Siempre forzar 'Inicio' (lane0) al principio
    const inicioLane = lanesData.find(l => l.id === 'lane0');
    const otherLanes = lanesData.filter(l => l.id !== 'lane0');

    let finalLanes = [];

    if (activeOrder && activeOrder.length > 0) {
      const orderedOthers = [];
      const laneMap = new Map(otherLanes.map(lane => [String(lane.id), lane]));

      // Adicionar lanes na ordem salva (solo las que no son lane0)
      activeOrder.forEach(laneId => {
        const idStr = String(laneId);
        if (idStr !== 'lane0' && laneMap.has(idStr)) {
          orderedOthers.push(laneMap.get(idStr));
          laneMap.delete(idStr);
        }
      });

      // Adicionar lanes restantes (novas lanes que não estavam na ordem salva)
      laneMap.forEach(lane => orderedOthers.push(lane));

      finalLanes = [inicioLane, ...orderedOthers];
    } else {
      finalLanes = [inicioLane, ...otherLanes];
    }

    if (selectedLanes && selectedLanes.length > 0) {
      const selectedIds = selectedLanes.map(l => l.id === "lane0" ? "lane0" : l.id.toString());
      finalLanes = finalLanes.filter(l => l && selectedIds.includes(l.id));
    }

    const hasActiveFilters = searchQuery !== "" || startDate !== "" || endDate !== "" || (selectedTags && selectedTags.length > 0);
    // [ANTIGRAVITY] Removido el auto-ocultamiento de columnas vacías porque rompía el Drag&Drop (el usuario no tenía donde soltar los tickets).
    // Si el usuario quiere ocultar columnas, debe usar explícitamente el filtro de "Etapas" (selectedLanes).

    setLanes(finalLanes.filter(Boolean));
  };

  useEffect(() => {
    if (!loadingLaneOrder) {
      organizeLanes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tags, tickets, sortOrder, laneOrder, loadingLaneOrder, selectedLanes]);

  useEffect(() => {
    fetchTickets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTags, selectedConnections]);

  const handleCardMove = async (ticketId, targetLaneId, sourceLaneId) => {
    const ticketIdInt = parseInt(ticketId, 10);
    const ticket = tickets.find(t => t.id === ticketIdInt);
    if (!ticket) return;

    // Obtener índices de las columnas
    const currentBoardTags = tags.map(tag => String(tag.id));
    // El ticket tiene una etiqueta que es la columna actual
    const currentLaneTag = ticket.tags?.find(tag => currentBoardTags.includes(String(tag.id)));

    // Si no tiene etiqueta de kanban (esta en Inicio)
    const currentLaneId = sourceLaneId || (currentLaneTag ? String(currentLaneTag.id) : "lane0");
    const destLaneId = targetLaneId || "lane0";

    if (String(currentLaneId) === String(destLaneId)) {
      return;
    }

    // Encontrar índices en el arreglo 'lanes' (que viene de la UI)
    const laneIds = lanes.map(l => l.id);
    const currentIndex = laneIds.indexOf(currentLaneId);
    const targetIndex = laneIds.indexOf(destLaneId);

    // Lógica de restricción de retroceso
    if (targetIndex < currentIndex) {
      if (user.profile === "admin") {
        // Los admins pueden retroceder siempre
      } else {
        // Usuarios comunes: Verificar si tiene CUALQUIER etiqueta que no sea de Kanban (acciones)
        const hasSubTags = ticket.tags?.some(tag => {
          return !currentBoardTags.includes(String(tag.id));
        });

        if (hasSubTags) {
          toast.error(i18n.t("kanban.errors.cannotMoveBackwardWithActions") || "No puedes retroceder porque ya hay acciones registradas en esta etapa.");
          return;
        }
        // Si no tiene acciones, permitimos el retroceso como "corrección de error"
      }
    }

    // [PLAN 1230] Interceptar arrastre a etapa de cierre (Ganado o Perdido)
    const destStage = tags.find(tag => String(tag.id) === String(destLaneId));
    if (destStage && (destStage.stageRole === "won" || destStage.stageRole === "lost")) {
      setClosingTicketData({
        ticket,
        destLaneId,
        currentLaneId,
        isWon: destStage.stageRole === "won",
        destStage,
        targetIndex,
        currentIndex
      });
      setFinalizacaoModalOpen(true);
      return;
    }

    const ticketValue = getOpportunityValue(ticket);

    // [PLAN 1130] Actualización reactiva instantánea e inmutable de los totales de columna
    setLaneTotals(prevTotals => {
      if (!prevTotals) return prevTotals;
      const src = prevTotals[currentLaneId] || { count: 1, value: ticketValue };
      const dst = prevTotals[destLaneId] || { count: 0, value: 0 };
      return {
        ...prevTotals,
        [currentLaneId]: {
          count: Math.max(0, (src.count || 0) - 1),
          value: Math.max(0, (src.value || 0) - ticketValue)
        },
        [destLaneId]: {
          count: (dst.count || 0) + 1,
          value: (dst.value || 0) + ticketValue
        }
      };
    });

    // DEFER to allow react-beautiful-dnd to finish its internal drag cleanup
    setTimeout(async () => {
      // 1. Actualización Optimista Local
      const newTickets = tickets.map(t => {
        if (t.id === ticketIdInt) {
          let updatedTags = [...(t.tags || [])];
          // Filtramos las etiquetas que son 'etapas' del board actual
          updatedTags = updatedTags.filter(tag => !currentBoardTags.includes(String(tag.id)));

          if (destLaneId !== 'lane0') {
            const newStage = tags.find(tag => String(tag.id) === String(destLaneId));
            if (newStage) {
              updatedTags.push(newStage);
            }
          }

          return { ...t, tags: updatedTags };
        }
        return t;
      });

      setTickets(newTickets);
      
      // Llamar a organizeLanes SINCRÓNICAMENTE con los nuevos tickets 
      // para evitar el Invariant failed de react-beautiful-dnd
      organizeLanes(tags, newTickets);

      try {
        // Determinar si enviamos noLog
        const isUndoMove = (targetIndex < currentIndex) && (user.profile !== "admin");
        const noLogParam = isUndoMove ? "?noLog=true" : "";

        // 2. Sincronización con el Servidor
        await api.delete(`/ticket-tags/${ticketIdInt}${noLogParam}`, {
          params: {
            kanbanBoardId: selectedBoard
          }
        });

        if (destLaneId !== 'lane0') {
          await api.post(`/ticket-tags/${ticketIdInt}/${destLaneId}${noLogParam}`, {}, {
            params: { origin: 'kanban' }
          });
        }

        // [PLAN 1130] Sincronizar totales oficiales del servidor
        fetchLaneTotals();
      } catch (err) {
        console.log(err);
        toastError(err);
        fetchTickets();
      }
    }, 0);
  };

  // [PLAN 1230] Confirmación de cierre comercial desde Kanban
  const handleFinalizarClosingMove = async (ticketData) => {
    if (!closingTicketData) return;
    const { ticket, destLaneId, currentLaneId, targetIndex, currentIndex } = closingTicketData;
    const ticketIdInt = ticket.id;
    const isWon = ticketData.finalizadoComVenda;
    const ticketValue = ticketData.valorVenda !== undefined && ticketData.valorVenda !== ""
      ? (parseFloat(ticketData.valorVenda) || 0)
      : getOpportunityValue(ticket);

    try {
      // 1. Actualizar ticket comercialmente con status closed
      await api.put(`/tickets/${ticketIdInt}`, {
        ...ticketData,
        sendFarewellMessage: false
      });

      // 2. Mover etiqueta en Kanban
      const isUndoMove = (targetIndex < currentIndex) && (user.profile !== "admin");
      const noLogParam = isUndoMove ? "?noLog=true" : "";

      await api.delete(`/ticket-tags/${ticketIdInt}${noLogParam}`, {
        params: {
          kanbanBoardId: selectedBoard
        }
      });

      if (destLaneId !== 'lane0') {
        await api.post(`/ticket-tags/${ticketIdInt}/${destLaneId}${noLogParam}`, {}, {
          params: { origin: 'kanban' }
        });
      }

      // 3. Totales de columna
      const oldTicketValue = getOpportunityValue(ticket);
      setLaneTotals(prevTotals => {
        if (!prevTotals) return prevTotals;
        const src = prevTotals[currentLaneId] || { count: 1, value: oldTicketValue };
        const dst = prevTotals[destLaneId] || { count: 0, value: 0 };
        return {
          ...prevTotals,
          [currentLaneId]: {
            count: Math.max(0, (src.count || 0) - 1),
            value: Math.max(0, (src.value || 0) - oldTicketValue)
          },
          [destLaneId]: {
            count: (dst.count || 0) + 1,
            value: (dst.value || 0) + ticketValue
          }
        };
      });

      // 4. Actualización optimista de tickets locales
      const currentBoardTags = tags.map(tag => String(tag.id));
      const newTickets = tickets.map(t => {
        if (t.id === ticketIdInt) {
          let updatedTags = [...(t.tags || [])].filter(tag => !currentBoardTags.includes(String(tag.id)));
          const newStage = tags.find(tag => String(tag.id) === String(destLaneId));
          if (newStage) {
            updatedTags.push(newStage);
          }
          return {
            ...t,
            status: "closed",
            finalizadoComVenda: isWon,
            motivoNaoVenda: ticketData.motivoNaoVenda,
            valorVenda: ticketValue,
            opportunityValue: ticketValue,
            tags: updatedTags
          };
        }
        return t;
      });

      setTickets(newTickets);
      organizeLanes(tags, newTickets);
      fetchLaneTotals();
      toast.success(i18n.t("tickets.finalizationModal.successClosed") || "Ticket finalizado con éxito.");
    } catch (err) {
      console.error(err);
      toastError(err);
      fetchTickets();
    } finally {
      setFinalizacaoModalOpen(false);
      setClosingTicketData(null);
    }
  };

  const handleCloseFinalizacaoModal = () => {
    setFinalizacaoModalOpen(false);
    setClosingTicketData(null);
    organizeLanes(tags, tickets);
  };

  const handleAddColumnClick = () => {
    history.push('/tagsKanban');
  };

  const handleSortOrderChange = event => {
    setSortOrder(event.target.value);
  };

  const handleLaneReorder = async (sourceIndex, destinationIndex) => {
    // Verificar se o usuário é admin
    if (user.profile !== 'admin') {
      toast.error(i18n.t('kanban.messages.errorReorder'));
      return;
    }

    // [PLAN 1090] Proteger coluna Inicio (lane0): no permitir moverla ni colocar otra columna antes de ella
    if (sourceIndex === 0) {
      return;
    }
    const effectiveDestIndex = Math.max(1, destinationIndex);

    const newLanes = Array.from(lanes);
    const [reorderedLane] = newLanes.splice(sourceIndex, 1);
    newLanes.splice(effectiveDestIndex, 0, reorderedLane);

    // Asegurar que Inicio (lane0) siempre esté en la posición 0
    const lane0Index = newLanes.findIndex(l => String(l.id) === 'lane0');
    if (lane0Index > 0) {
      const [lane0] = newLanes.splice(lane0Index, 1);
      newLanes.unshift(lane0);
    }

    setLanes(newLanes);

    // Salvar nova ordem no banco de dados normalizada en strings
    const newLaneOrder = newLanes.map(lane => String(lane.id));
    setLaneOrder(newLaneOrder);

    try {
      await setKanbanLaneOrder(newLaneOrder, selectedBoard);
      toast.success(i18n.t('kanban.messages.successReorder'));
    } catch (error) {
      console.error('Erro ao salvar ordem das lanes:', error);
      toast.error(i18n.t('kanban.messages.errorSaveReorder'));
    }
  };

  const handleCloseBoardModal = () => {
    setBoardModalOpen(false);
    setEditingBoardId(null);
    // Refresh boards list
    const fetchBoards = async () => {
      try {
        const { data } = await api.get("/kanban-boards");
        setBoards(data);
        // If no board selected (e.g. first one created), select it
        // if (!selectedBoard && data.length > 0) {
        //   setSelectedBoard(data[0].id);
        // }
      } catch (err) {
        toastError(err);
      }
    };
    fetchBoards();
  };

  const handleEditBoard = () => {
    if (selectedBoard !== "0") {
      setEditingBoardId(Number(selectedBoard));
      setBoardModalOpen(true);
    }
  };

  const handleAddBoard = () => {
    setEditingBoardId(null);
    setBoardModalOpen(true);
  };



  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [boardToExport, setBoardToExport] = useState("");

  const handleOpenExportModal = () => {
    setBoardToExport(selectedBoard);
    setExportModalOpen(true);
  };

  const handleConfirmExport = async () => {
    if (!boardToExport) return;
    try {
      const { data } = await api.get(`/kanban-boards/${boardToExport}/export`);
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `kanban-export-${data.name}.json`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      setExportModalOpen(false);
      toast.success(i18n.t("kanban.messages.exportSuccess") || "Tablero exportado con éxito");
    } catch (err) {
      toastError(err);
    }
  };

  const handleImportBoard = () => {
    setImportWhatsappId("");
    setImportModalOpen(true);
  };

  const handleImportConfirm = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
    setImportModalOpen(false);
  };

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [boardToDelete, setBoardToDelete] = useState("");

  const handleOpenDeleteModal = () => {
    setBoardToDelete(selectedBoard);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!boardToDelete || boardToDelete === "0") return;

    try {
      await api.delete(`/kanban-boards/${boardToDelete}`);
      toast.success(i18n.t("kanban.messages.deleteSuccess") || "Tablero eliminado con éxito");

      // Refresh boards list
      const { data } = await api.get("/kanban-boards");
      setBoards(data);
      setSelectedBoard(null);
      setDeleteModalOpen(false);
    } catch (err) {
      const errorMsg = err.response?.data?.error;
      if (errorMsg === "ERR_BOARD_HAS_TICKETS" || err.response?.status === 409) {
        toast.error(i18n.t("backendErrors.ERR_BOARD_HAS_TICKETS"));
      } else {
        toastError(err);
      }
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const json = JSON.parse(e.target.result);
        const payload = {
          ...json,
          whatsappId: importWhatsappId ? Number(importWhatsappId) : null
        };
        const { data: newBoard } = await api.post('/kanban-boards/import', payload);
        toast.success(i18n.t("kanban.messages.importSuccess"));

        // Refresh
        const { data } = await api.get("/kanban-boards");
        setBoards(data);
        if (newBoard && newBoard.id) {
          setSelectedBoard(newBoard.id);
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error === "ERR_BOARD_NAME_EXISTS") {
          toast.error(i18n.t("kanban.errors.boardNameExists"));
        } else {
          toastError(err);
        }
      }
    };
    reader.readAsText(file);
    e.target.value = null;
  };

  const handleFixTags = async () => {
    try {
      if (!window.confirm("¿Seguro que deseas reparar las etiquetas de los tableros? Esta acción separará las etiquetas duplicadas.")) return;
      const { data } = await api.post("/kanban-boards/fix-tags");
      toast.success(data.message || "Etiquetas reparadas con éxito");
      // Optional: Refresh board logic if needed
      if (selectedBoard) fetchTags();
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <MainContainer>
      <Paper elevation={0} variant="outlined" className={classes.rootPaper}>
        <MainHeader>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Box display="flex" alignItems="center" style={{ gap: 14, marginBottom: 16 }}>
              <PageHelpGuide
                helpData={KANBAN_HELP_DATA}
                tooltipText="Guía y Ayuda de Kanban / Embudos (Haz clic para ver)"
              />
              <Typography
                variant="h5"
                style={{
                  fontWeight: 700,
                  color: theme.palette.type === "dark" ? "#FFF" : theme.palette.primary.main,
                  letterSpacing: "-0.5px",
                }}
              >
              {i18n.t('tagsKanban.title')}
            </Typography>
          </Box>
          
          <Paper className={classes.filterPaper} elevation={0}>
            
            {/* FILA 1: Secuencia lógica (Marca -> Embudo -> Etapa -> Etiqueta -> Conexión) */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', width: '100%' }}>
              
              <TextField
                select
                label={i18n.t("kanban.filters.brand")}
                variant="outlined"
                size="small"
                value={selectedBrand}
                onChange={(e) => {
                  const brandVal = e.target.value ? Number(e.target.value) : "";
                  setSelectedBrand(brandVal);
                  setSelectedBoard(null);
                  setSelectedLanes([]);
                  setSelectedTags([]);
                  setSelectedConnections([]);
                  localStorage.removeItem('kanbanSelectedBrand');
                  localStorage.removeItem('kanbanSelectedBoard');
                }}
              >
                <MenuItem value=""><em>{i18n.t("kanban.filters.brandPlaceholder")}</em></MenuItem>
                {brands.map((b) => (
                  <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>
                ))}
              </TextField>

              <TextField
                select
                label={i18n.t("kanban.filters.funnel")}
                variant="outlined"
                size="small"
                value={selectedBoard || ""}
                onChange={(e) => {
                  const boardVal = e.target.value ? Number(e.target.value) : null;
                  setSelectedBoard(boardVal);
                  setSelectedLanes([]);
                  setSelectedTags([]);
                  setSelectedConnections([]);
                  localStorage.removeItem('kanbanSelectedBoard');
                }}
                disabled={!selectedBrand}
              >
                <MenuItem value="" disabled><em>{i18n.t("kanban.filters.funnelPlaceholder")}</em></MenuItem>
                {boards.filter(b => Number(b.brandId) === Number(selectedBrand)).map((b) => (
                  <MenuItem key={b.id} value={b.id}>
                    {b.name}
                  </MenuItem>
                ))}
              </TextField>

              <Autocomplete
                multiple
                size="small"
                disabled={!selectedBoard}
                options={(() => {
                  if (!selectedBoard) return [];
                  const boardLanes = tags.filter(t => t.kanbanBoardId === selectedBoard);
                  return [{ id: "lane0", name: i18n.t("tagsKanban.laneDefault"), color: "#757575" }, ...boardLanes];
                })()}
                value={selectedLanes}
                onChange={(e, v) => setSelectedLanes(v)}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip variant="outlined" style={{ backgroundColor: option.color || "#eee", color: "white" }} label={option.name} {...getTagProps({ index })} size="small" />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label={i18n.t("kanban.filters.filterByStage")} />
                )}
              />

              <Autocomplete
                multiple
                size="small"
                disabled={!selectedBoard}
                options={(() => {
                  if (!selectedBoard) return [];
                  let filteredTags = tags;
                  if (selectedLanes.length > 0) {
                    const laneIds = selectedLanes.map(l => String(l.id));
                    filteredTags = tags.filter(t => {
                      if (!t.kanbanBoardId) return true; 
                      return laneIds.includes(String(t.kanbanBoardId));
                    });
                  }
                  return filteredTags;
                })()}
                groupBy={(option) => {
                  if (!option.kanbanBoardId) return i18n.t("kanban.filters.groupGeneral");
                  const p = tags.find(x => x.id === option.kanbanBoardId);
                  return p ? p.name : i18n.t("kanban.filters.groupOther");
                }}
                value={selectedTags}
                onChange={(e, v) => setSelectedTags(v)}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip variant="outlined" style={{ backgroundColor: option.color || "#eee", color: "white" }} label={option.name} {...getTagProps({ index })} size="small" />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label={i18n.t("kanban.filters.filterByTags")} />
                )}
              />

              <Autocomplete
                multiple
                size="small"
                disabled={!selectedBoard}
                options={whatsapps.filter(w => {
                  // Only show whatsapps that are linked to this specific board or its brand!
                  const currentBoard = boards.find(b => b.id === selectedBoard);
                  if (!currentBoard) return false;
                  if (currentBoard.whatsapps && currentBoard.whatsapps.length > 0) {
                    return currentBoard.whatsapps.some(wp => wp.id === w.id);
                  }
                  if (currentBoard.brandId) {
                    return Number(w.brandId) === Number(currentBoard.brandId);
                  }
                  return false;
                })}
                value={selectedConnections}
                onChange={(e, v) => setSelectedConnections(v)}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip variant="outlined" style={{ backgroundColor: option.color || "#eee", color: "white" }} label={option.name} {...getTagProps({ index })} size="small" />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label={i18n.t("kanban.filters.filterByConnection")} />
                )}
              />
            </div>

            {/* FILA 2: Acciones del Embudo */}
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', width: '100%', flexWrap: 'wrap', justifyContent: 'space-between' }}>
              
              
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <Button 
                  variant="outlined" 
                  size="small"
                  className={classes.secondaryButton}
                  onClick={() => setAdminModalOpen(true)}
                >
                  {i18n.t("kanban.filters.administration")}
                </Button>
              </div>

              <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
                <FormControlLabel
                  control={<Checkbox checked={showClosed} onChange={(e) => setShowClosed(e.target.checked)} color="primary" />}
                  label={i18n.t("kanban.filters.showClosed")}
                />
                <FormControlLabel
                  control={<Checkbox checked={showUnique} onChange={(e) => setShowUnique(e.target.checked)} color="primary" />}
                  label={i18n.t("kanban.filters.showUnique")}
                />
                <FormControlLabel
                  control={<Checkbox checked={showDashboard} onChange={(e) => setShowDashboard(e.target.checked)} color="primary" />}
                  label={i18n.t("kanban.filters.dashboard")}
                />
                
                <TextField
                  select
                  label={i18n.t("kanban.filters.sortBy")}
                  variant="outlined"
                  size="small"
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e.target.value)}
                  style={{ minWidth: 150 }}
                >
                  <MenuItem value="id_desc">{i18n.t("kanban.filters.sortOptions.ticketNumber")}</MenuItem>
                  <MenuItem value="updatedAt_desc">{i18n.t("kanban.filters.sortOptions.recent")}</MenuItem>
                  <MenuItem value="updatedAt_asc">{i18n.t("kanban.filters.sortOptions.oldest")}</MenuItem>
                  <MenuItem value="value_desc">{i18n.t("kanban.filters.sortOptions.highestValue")}</MenuItem>
                </TextField>
              </div>
            </div>

            {/* FILA 3: Búsqueda y Botón Exportar Datos */}
            <div style={{ display: 'flex', gap: '16px', alignItems: 'center', width: '100%', flexWrap: 'wrap' }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                style={{ flex: 1 }}
                placeholder={i18n.t("kanban.filters.searchPlaceholder")}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSearchClick()}
              />
              <TextField
                variant="outlined"
                size="small"
                type="date"
                label={i18n.t("kanban.filters.startDate")}
                InputLabelProps={{ shrink: true }}
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
              <TextField
                variant="outlined"
                size="small"
                type="date"
                label={i18n.t("kanban.filters.endDate")}
                InputLabelProps={{ shrink: true }}
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
              <Button
                variant="outlined"
                size="small"
                className={classes.applyButton}
                onClick={handleSearchClick}
              >
                {i18n.t("kanban.filters.searchButton")}
              </Button>
              <Button
                variant="outlined"
                size="small"
                className={classes.applyButton}
                startIcon={<GetAppIcon style={{ fontSize: 18 }} />}
                onClick={handleOpenExportModal}
              >
                {i18n.t("kanban.filters.exportButton")}
              </Button>
            </div>
          </Paper>
        </div>
      </MainHeader>

      <div className={classes.mainPaper}>
        {(!selectedBoard || boards.length === 0) ? (
          <div style={{ padding: 40, textAlign: 'center' }}>
            <Typography variant="body1" color="textSecondary" style={{ fontSize: '1.2rem' }}>
              {i18n.t("kanban.filters.emptyStateMessage")}
            </Typography>
          </div>
        ) : (
          <>
            <ErrorBoundary>
              <KanbanBoard
                lanes={lanes}
                onCardMove={handleCardMove}
                onLaneReorder={handleLaneReorder}
                updateTicket={updateTicket}
                isAdmin={user.profile === 'admin'}
                boardId={selectedBoard}
                boardLanes={lanes} // Pasamos lanes completos
                handleOpenTagMenu={handleOpenTagMenu} // Pasamos el manejador
                laneTotals={laneTotals}
                lanePagination={lanePagination}
                fetchMoreTickets={fetchMoreTickets}
                currency={currency}
                onValueChange={handleTicketValueChange}
              />
            </ErrorBoundary>

            <KanbanTagMenu
              position={tagMenuConfig ? tagMenuConfig.position : null}
              ticket={tagMenuConfig ? tagMenuConfig.ticket : null}
              lanes={lanes}
              currentLaneId={tagMenuConfig ? tagMenuConfig.laneId : null}
              onClose={handleCloseTagMenu}
              updateTicket={(t) => updateTicket(t)}
              setTargetLaneIdForAdd={(id) => {
                setTargetLaneIdForAdd(id);
                setAddSubTagModalOpen(true);
              }}
              setAddSubTagModalOpen={setAddSubTagModalOpen}
            />

            {/* Modal Global para Añadir Sub-Etiqueta */}
            <Dialog open={addSubTagModalOpen} onClose={() => setAddSubTagModalOpen(false)}>
              <DialogTitle>{i18n.t("kanban.labels.addTitle")}</DialogTitle>
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  label={i18n.t("kanban.labels.labelName")}
                  fullWidth
                  value={newSubTagName}
                  onChange={(e) => setNewSubTagName(e.target.value)}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setAddSubTagModalOpen(false)} color="secondary">
                  {i18n.t("kanban.buttons.cancel")}
                </Button>
                <Button onClick={handleSaveSubTag} color="primary">
                  {i18n.t("kanban.card.save")}
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </div>
    </Paper>

      {adminModalOpen && (
        <KanbanAdminModal
          open={adminModalOpen}
          onClose={() => setAdminModalOpen(false)}
          brands={brands}
          boards={boards}
          reloadKanban={async () => {
            try {
              const [brandsRes, boardsRes] = await Promise.all([
                api.get("/brands"),
                api.get("/kanban-boards")
              ]);
              setBrands(brandsRes.data.brands || brandsRes.data);
              setBoards(boardsRes.data);

              if (selectedBoard) {
                const refreshedOrder = await getKanbanLaneOrder(selectedBoard);
                setLaneOrder(refreshedOrder);
                laneOrderRef.current = refreshedOrder;
                fetchTags();
              }
            } catch (e) {
              console.error("Error refreshing kanban state after admin changes", e);
            }
          }}
          onExport={handleOpenExportModal}
          onImport={handleFileChange}
          fileInputRef={fileInputRef}
        />
      )}

      {boardModalOpen && (
        <KanbanBoardModal
          open={boardModalOpen}
          onClose={handleCloseBoardModal}
          boardId={editingBoardId}
          brandId={selectedBrand}
        />
      )}

      {/* Export Selection Modal */}
      <Dialog open={exportModalOpen} onClose={() => setExportModalOpen(false)}>
        <DialogTitle>{i18n.t("kanban.exportModal.title")}</DialogTitle>
        <DialogContent>
          <FormControl variant="outlined" fullWidth margin="dense">
            <InputLabel>{i18n.t("kanban.exportModal.selectLabel")}</InputLabel>
            <Select
              value={boardToExport}
              onChange={(e) => setBoardToExport(e.target.value)}
              label={i18n.t("kanban.exportModal.selectLabel")}
            >
              {boards.map((b) => (
                <MenuItem key={b.id} value={b.id}>
                  {b.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setExportModalOpen(false)} color="secondary">
            {i18n.t("kanban.buttons.cancel")}
          </Button>
          <Button onClick={handleConfirmExport} color="primary" variant="contained">
            {i18n.t("kanban.buttons.export")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Selection Modal */}
      <Dialog open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
        <DialogTitle>{i18n.t("kanban.deleteModal.title")}</DialogTitle>
        <DialogContent>
          <FormControl variant="outlined" fullWidth margin="dense">
            <InputLabel>{i18n.t("kanban.deleteModal.selectLabel")}</InputLabel>
            <Select
              value={boardToDelete}
              onChange={(e) => setBoardToDelete(e.target.value)}
              label={i18n.t("kanban.deleteModal.selectLabel")}
            >
              {boards.map((b) => (
                <MenuItem key={b.id} value={b.id}>
                  {b.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteModalOpen(false)} color="primary">
            {i18n.t("kanban.buttons.cancel")}
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary" variant="contained">
            {i18n.t("kanban.buttons.deleteBoard")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* [PLAN 1230] Modal de Finalización Comercial en Kanban */}
      {finalizacaoModalOpen && closingTicketData && (
        <FinalizacaoVendaModal
          open={finalizacaoModalOpen}
          onClose={handleCloseFinalizacaoModal}
          ticket={closingTicketData.ticket}
          initialVendaConcluida={closingTicketData.isWon}
          onFinalizar={handleFinalizarClosingMove}
        />
      )}
    </MainContainer>
  );
};

export default Kanban;
